var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 13C17.9533 13 20 11.1038 20 8.76471C20 6.91084 18.7144 5.33518 16.9241 4.76123C16.6697 2.64528 14.7327 1 12.381 1C9.85622 1 7.80952 2.89621 7.80952 5.23529C7.80952 5.75265 7.90965 6.24835 8.09293 6.70665C7.878 6.66755 7.65587 6.64706 7.42857 6.64706C5.53502 6.64706 4 8.06921 4 9.82353C4 11.5778 5.53502 13 7.42857 13H15.4286Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H19C20.1046 15 21 15.8954 21 17V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V17C3 15.8954 3.89543 15 5 15ZM6.75 17.5C6.75 17.0858 6.41421 16.75 6 16.75C5.58579 16.75 5.25 17.0858 5.25 17.5V19.5C5.25 19.9142 5.58579 20.25 6 20.25C6.41421 20.25 6.75 19.9142 6.75 19.5V17.5ZM9.75 17.5C9.75 17.0858 9.41421 16.75 9 16.75C8.58579 16.75 8.25 17.0858 8.25 17.5V19.5C8.25 19.9142 8.58579 20.25 9 20.25C9.41421 20.25 9.75 19.9142 9.75 19.5V17.5ZM12.0002 19.2499H18.0002C18.4144 19.2499 18.7502 18.9142 18.7502 18.4999C18.7502 18.0857 18.4144 17.7499 18.0002 17.7499H12.0002C11.586 17.7499 11.2502 18.0857 11.2502 18.4999C11.2502 18.9142 11.586 19.2499 12.0002 19.2499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud3);
export default __webpack_public_path__ + "static/media/cloud-3.46ad29f90cded0f46e01be0ed2e6d2d8.svg";
export { ForwardRef as ReactComponent };